import { createFileRoute } from '@tanstack/react-router';

import { PlatformPractitionerListScreen } from '@/features/practitioners/components/platform/PractitionerListScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/platform/practitioners/')({
  beforeLoad: () => {
    requirePermission('practitioner:read');
  },
  component: PlatformPractitionerListScreen,
  staticData: { crumb: 'Practitioners' },
});
